import { PersistenceDimensionKey, WellbeingDimensionKey } from './AssessmentIndex.types';

// The bound each dimension is scored against. Fixed rather than per-run, so the endpoint states it in
// the SaiStudentDetailIndices dimension-type descriptions instead of serving it as a field. The index
// bound (MAX_INDEX_SCORE) is shared with the Beacon list, so it lives in Components/Beacon/constants.
export const MAX_DIMENSION_SCORE = 10;

// Declaration order is the order the radar draws its axes, taken from the product mock. Each map is
// total over the dimension keys the detail query selects, so a dimension the query gains has to be
// named before this compiles, and the radar and the flag breakdown both read the list built from it.
export const PERSISTENCE_DIMENSION_LABELS: Record<PersistenceDimensionKey, string> = {
  personalWellness: 'Personal Wellness',
  campusBelonging: 'Campus Belonging',
  academicMomentum: 'Academic Momentum',
  lifeStability: 'Life Stability',
};

export const WELLBEING_DIMENSION_LABELS: Record<WellbeingDimensionKey, string> = {
  emotional: 'Emotional',
  spiritual: 'Spiritual',
  environmental: 'Environmental',
  occupational: 'Occupational',
  financial: 'Financial',
  social: 'Social',
  physical: 'Physical',
  intellectual: 'Intellectual',
};

export const PERSISTENCE_DIMENSIONS = (
  Object.keys(PERSISTENCE_DIMENSION_LABELS) as PersistenceDimensionKey[]
).map(key => ({ key, label: PERSISTENCE_DIMENSION_LABELS[key] }));

export const WELLBEING_DIMENSIONS = (
  Object.keys(WELLBEING_DIMENSION_LABELS) as WellbeingDimensionKey[]
).map(key => ({ key, label: WELLBEING_DIMENSION_LABELS[key] }));

export const WELLBEING_COLOR = '#6F70F4';
export const WELLBEING_FILL = 'rgba(111, 112, 244, 0.22)';
export const PERSISTENCE_COLOR = '#1FA82E';
export const PERSISTENCE_FILL = 'rgba(31, 168, 46, 0.22)';
export const RADAR_BAND_COLOR = '#F1F2F4';
